const REACT_APP_CRYPTO_STORE_HOME_MICROFRONTEND = process.env.REACT_APP_CRYPTO_STORE_HOME_MICROFRONTEND;

export { REACT_APP_CRYPTO_STORE_HOME_MICROFRONTEND };
